import { render, staticRenderFns } from "./ImportPayments.vue?vue&type=template&id=7221a9ab&scoped=true"
import script from "./ImportPayments.vue?vue&type=script&lang=js"
export * from "./ImportPayments.vue?vue&type=script&lang=js"
import style0 from "./ImportPayments.vue?vue&type=style&index=0&id=7221a9ab&prod&lang=scss&scoped=true"
import style1 from "./ImportPayments.vue?vue&type=style&index=1&id=7221a9ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7221a9ab",
  null
  
)

export default component.exports